// extracted by mini-css-extract-plugin
export default {"social-media":"style_social-media__ndJt-","social-media-page":"style_social-media-page__lqISF"};